import { render } from "./InternalOrderCancerTreatmentPatternInterventions.vue?vue&type=template&id=45ac916e&scoped=true"
import script from "./InternalOrderCancerTreatmentPatternInterventions.vue?vue&type=script&lang=js"
export * from "./InternalOrderCancerTreatmentPatternInterventions.vue?vue&type=script&lang=js"

import "./InternalOrderCancerTreatmentPatternInterventions.vue?vue&type=style&index=0&id=45ac916e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ac916e"]])

export default __exports__